// @flow

import * as React from 'react';

import s from './Checkbox.scss';

type Props = {
  label: string | number,
  name: string | number,
  checked: boolean,
  onChange: (e: SyntheticEvent<any>) => void,
  disabled: boolean,
}

export const Checkbox = (props: Props) => {
  const { label, name, checked, onChange, disabled } = props;

  return (
    <div id={s.checkbox_wrapper}>
      <input
        className={s.checkbox}
        type="checkbox"
        id={name}
        name={name}
        checked={checked || false}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={name} className={s.checkbox_label}>{label}</label>
    </div>
  )
}



export default Checkbox;
